import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { HOTEL_URL, BASE_URL, ADMIN_URL } from './constant/BaseApiUrl';

export default class HotelManagementService {
  getListHotel() {
    return axios.get(`${HOTEL_URL}${ApiKey.HOTELS}/list-for-management`);
  }
  updateHotelStatus(code, status, type) {
    return axios.put(`${HOTEL_URL}${ApiKey.HOTELS}/${code}/status?status=${status}&type=${type}`);
  }

  getListNotes(code, type) {
    return axios.get(`${HOTEL_URL}${ApiKey.HOTELS}/${code}/notes/${type}`);
  }

  updateTypeCallRoom(id, option) {
    return axios.post(`${HOTEL_URL}${ApiKey.HOTELS}/${id}/room-category-call-order/${option}`);
  }

  addNotes(code, payload, type) {
    return axios.post(`${HOTEL_URL}${ApiKey.HOTELS}/${code}/notes/${type}`, payload);
  }

  deleteNotes(code, noteId, type) {
    return axios.delete(`${HOTEL_URL}${ApiKey.HOTELS}/${code}/notes/${noteId}/${type}`);
  }

  updatePreferred(code, type, payload) {
    return axios.put(`${HOTEL_URL}${ApiKey.HOTELS}/${code}/preferences/${type}`, payload);
  }

  syncData() {
    return axios.get(`${HOTEL_URL}${ApiKey.SYNC_DATA}`);
  }

  getFileJson() {
    return axios.get(`${HOTEL_URL}${ApiKey.GATEWAY_AIRPORT_CODE}`);
  }

  updateFileJson(payload) {
    return axios.post(`${HOTEL_URL}${ApiKey.GATEWAY_AIRPORT_CODE}`, payload, {
      headers: {
        'content-type': 'text/plain'
      }
    });
  }

  updateHotelData(code, payload) {
    return axios.put(`${HOTEL_URL}${ApiKey.HOTELS}/${code}`, payload);
  }

  excludeHotelRoom(id, payload) {
    return axios.post(`${HOTEL_URL}${ApiKey.HOTELS}/${id}/exclude-hotel-room`, payload);
  }

  getAvgPaxRoom() {
    return axios.get(`${HOTEL_URL}${ApiKey.HOTELS}/avg-pax-room`);
  }

  updateAvgPaxRoom(payload) {
    return axios.put(`${HOTEL_URL}${ApiKey.HOTELS}/avg-pax-room`, payload);
  }

  getPricingQuote(id, body) {
    return axios.post(`${BASE_URL}${ApiKey.GET_PRICING_QUOTE}/${id}/hotel-pricing`, body);
  }

  getHcmsPromotion(id, body) {
    return axios.post(`${BASE_URL}${ApiKey.GET_PRICING_QUOTE}/${id}/hcms-promotion`, body);
  }

  getHotelInfo(ttsCode) {
    return axios.get(`${HOTEL_URL}${ApiKey.HOTELS}/${ttsCode}/info`);
  }

  addNewHotel(payload) {
    return axios.post(`${HOTEL_URL}${ApiKey.HOTELS}`, payload);
  }

  deleteHotel(id) {
    return axios.delete(`${HOTEL_URL}${ApiKey.HOTELS}/${id}`);
  }

  getUrlPreview() {
    return `${HOTEL_URL}${ApiKey.HOTELS}/${ApiKey.PREVIEW_FILE}`;
  }

  importFileHotel(payload) {
    return axios.post(`${HOTEL_URL}${ApiKey.HOTELS}/${ApiKey.IMPORT_FILE}`, payload);
  }

  getVersionRevert(fileType) {
    return axios.get(`${ADMIN_URL}${ApiKey.ADMINISTRATION}/file?fileType=${fileType}`);
  }

  revertVersion(payload) {
    return axios.post(`${HOTEL_URL}${ApiKey.HOTELS}/${ApiKey.REVERT_FILE}`, payload);
  }

  getPreviewByFileName(fileName, type) {
    return axios.post(`${HOTEL_URL}${ApiKey.HOTELS}/${ApiKey.URL_FILE}/${ApiKey.PREVIEW_FILE}?fileType=${type}`, fileName, {
      headers: {
        'content-type': 'text/plain'
      }
    });
  }
}
